import Alpine from "alpinejs";
import { isUrlExternal } from "is-url-external";
import internalLink from "../../modules/track/modules/link/linkTypes/internalLink";
import downloadLink from "../../modules/track/modules/link/linkTypes/downloadLink";
import siteConfig from "../../modules/siteConfig";

Alpine.magic("openModal", () => (id) => {
  return modalEvent("open-modal", id);
});

Alpine.magic("closeModal", () => (id) => {
  return modalEvent("close-modal", id);
});

Alpine.magic("filterUrlsFromAccessList", () => (filterRule, accessList, id) => {
  document.body.addEventListener("click", function (e) {
    let targetElement = getTargetLink(e.target);
    if (targetElement) {
      let reference = targetElement.getAttribute("href");
      let referenceTarget = targetElement.getAttribute("target") || "_self";
      // return true if link is found in accessList based on the fitler rule set in the dialog & open modal
      if (filterLink(reference, accessList, filterRule)) {
        // set proceed link
        const modalStore = Alpine.store("modal");
        modalStore.setProceedLink(reference, referenceTarget, id);
        //dont open modal or prevent if the link is on the current open modal
        if (!targetElement.classList.contains(`exitLink-${id}`)) {
          // prevent link clicked from proceeding
          e.preventDefault();
          //set proceed link on modal button type
          modalEvent("open-modal", id);
        }
      }
    }
  });
});

Alpine.magic("isModalRendered", () => (id, type) => {
  if (siteConfig.isEditMode) return false; // skip modal rendering in author mode

  const modalStore = Alpine.store("modal");
  if (type == "entryModal") {
    modalStore.add(id); // add modal to rendered modal list
  }
  return modalStore.has(id);
});

function modalEvent(eventType, id) {
  if (eventType == "open-modal") {
    const modalStore = Alpine.store("modal");
    modalStore.add(id); // add modal to rendered modal list
  }
  const event = new CustomEvent(eventType, { detail: { id } });
  return window.dispatchEvent(event);
}

function filterLink(href, accessList, filterRule) {
  let isRegisteredLink = false;

  // Skip special protocols we never want to register
  if (/^(mailto:|tel:)/i.test(href)) {
    return false;
  }

  switch (filterRule) {
    case "whitelist": {
      const origin = window.location.origin;

      const isInternal = new RegExp("^" + origin, "g");
      const isInternalLink = internalLink.test({ link: href, isInternal });

      const isDamAsset = downloadLink.test({ link: href });

      const isHash = /^#/;
      const isHashUrl = isHash.test(href);

      isRegisteredLink =
        !isHashUrl &&
        !isDamAsset &&
        !isInternalLink &&
        !accessList.includes(href);
      break;
    }

    case "blacklist":
      isRegisteredLink = accessList.includes(href);
      break;

    default: {
      const externalURL = isUrlExternal(
        href,
        window.location.hostname.replace(/^www\./, "")
      );
      if (externalURL) {
        isRegisteredLink = true;
      }
    }
  }
  return isRegisteredLink;
}


const getTargetLink = function (target) {
  let el = null;
  if (target.localName == "a" && target.dataset.skipModal !== "true") {
    el = target;
  } else {
    let targetEl = target.closest("a");
    if (targetEl && targetEl.dataset.skipModal !== "true") {
      // when anchor link has html tag inside
      el = targetEl;
    }
  }
  return el;
};
